function accordionToggle(e) {
  var item = e;
  var items = document.querySelectorAll(".accordion-faq button");
  if(item != null) {
    if(item.getAttribute('aria-expanded') == 'false') {
      items.forEach(item => item.setAttribute('aria-expanded', 'false'));
      item.setAttribute('aria-expanded', 'true');
    }
    else {
      items.forEach(item => item.setAttribute('aria-expanded', 'false'));
    }
  }
}

window.addEventListener('DOMContentLoaded', (event) => {
  accordionToggle()
});

document.addEventListener("shopify:section:load", function(event) {
  accordionToggle()
});

